<template>
    <form v-on:submit.prevent="unlockBook">
        <input placeholder="password" type="text" v-model="password"/>
        <input type="submit" value="unlock" />
    </form>
</template>

<script>
export default {
    data() {
        return {
            book: null,
            password: '',
        }
    },
    created() {
        this.getBook();
    },
    methods: {
        async getBook() {
            this.book = await this.$store.dispatch('aGetBook', this.$store.state.notes.unlocking);
        },
        unlockBook() {
            // hash the user's input and compare it to the hash on the book
            const usersHashedInput = this.hashCode(this.password);
            let success = String(usersHashedInput) === String(this.book.password);
            this.$store.dispatch('aUnlockBook', this.book);
            console.log('success', success, usersHashedInput, this.book.password);
        },
        hashCode(text) {
            var hash = 0,
                i,
                chr;
            for (i = 0; i < text.length; i++) {
                chr = text.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        },
    }
};
</script>

<style lang="scss">
</style>
